import styled from 'styled-components';
import { ReactElement } from 'react';

import { StatusBadge, StyledFlex } from '@dreryk/react-components';
import { Translate } from '@dreryk/react-common';

import { translationKeys } from './translations';

const SideAiAssistantSidePanelTitle = styled.h3`
   margin-top: 24px;
   margin-left: 16px;
`;
SideAiAssistantSidePanelTitle.displayName = 'SidePanelContentSlotHeader';

export const AiAssistantSidePanelTitle = (): ReactElement => {
   return (
      <StyledFlex gap={16}>
         <SideAiAssistantSidePanelTitle>
            <Translate>{translationKeys.panel.title}</Translate>
            <StatusBadge testId={'beta'} type={'inProgress'} compact>
               {'beta'}
            </StatusBadge>
         </SideAiAssistantSidePanelTitle>
      </StyledFlex>
   );
};
